import React from 'react';
import './styles.scss';

export interface RuleChipInputProps {
    value: string[];
    onChange: (next: string[]) => void;
}

const ChipInput = ({ value, onChange }: RuleChipInputProps) => {
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter' || e.key === ',') {
            e.preventDefault();
            const v = e.currentTarget.value.trim();
            if (v && !value.includes(v)) {
                onChange([...value, v]);
            }
            e.currentTarget.value = '';
        }
        if (e.key === 'Backspace' && !e.currentTarget.value && value.length) {
            onChange(value.slice(0, -1));
        }
    };

    return (
        <div className="rb-chip-input">
            {value.map((chip, i) => (
                <span key={i} className="rb-chip-input__tag">
                    {chip}
                    <button
                        type="button"
                        className="rb-chip-input__remove"
                        onClick={() => onChange(value.filter((_, idx) => idx !== i))}
                    >
                        ×
                    </button>
                </span>
            ))}
            <input
                className="rb-chip-input__field"
                onKeyDown={handleKeyDown}
                placeholder={value.length ? '' : 'Type and press Enter…'}
            />
        </div>
    );
};

export default ChipInput;
